import { Divider, Fade, ListItemText, MenuItem, MenuList, Popper } from '@mui/material';
import React, {  useRef } from 'react';
import { TabMenuPaper } from '@styles/StyledTabs';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';

interface ITabContextMenuProps {
  open: boolean;
  anchorEl: null | HTMLElement;

  setOpen(val: boolean): void;

  onClose(evt: React.MouseEvent): void;

  onCloseLeft(evt: React.MouseEvent): void;

  onCloseRight(evt: React.MouseEvent): void;

  onCloseAll(evt: React.MouseEvent): void;

  onCopy(evt: React.MouseEvent): void;
}

export const TabContextMenu =({
  open,
  anchorEl,
  setOpen,
  onClose,
  onCloseLeft,
  onCloseRight,
  onCloseAll,
  onCopy,
}: ITabContextMenuProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, () => setOpen(false));

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? 'spring-popper' : undefined;

  return (
    <Popper ref={ref} transition id={id} open={open} anchorEl={anchorEl} sx={{ zIndex: 10 }}>
      {({ TransitionProps }) => (
        <Fade {...TransitionProps}>
          <TabMenuPaper>
            <MenuList dense>
              <MenuItem onClick={() => {window.location.reload();}}>
                <ListItemText>Reload</ListItemText>
              </MenuItem>
              <Divider />
              <MenuItem onClick={onClose}>
                <ListItemText>Close Tab</ListItemText>
              </MenuItem>
              <MenuItem onClick={onCloseRight}>
                <ListItemText>Close Tabs to the Right</ListItemText>
              </MenuItem>
              <MenuItem onClick={onCloseLeft}>
                <ListItemText>Close Tabs to the Left</ListItemText>
              </MenuItem>
              <Divider />
              <MenuItem onClick={onCloseAll}>
                <ListItemText>Close All Tabs</ListItemText>
              </MenuItem>
              <Divider />
              <MenuItem onClick={onCopy}>
                <ListItemText>Duplicate Tab</ListItemText>
              </MenuItem>
            </MenuList>
          </TabMenuPaper>
        </Fade>
      )}
    </Popper>
  );
};
